import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Нашата Сватба';
const DEFAULT_DESCRIPTION = 'Създайте лесно и бързо своя сватбен уебсайт с красиви шаблони, галерия за снимки от гостите, RSVP имейли, таймлайн и броене до деня.';
const DEFAULT_OG_IMAGE = 'https://www.nashatasvatba.in/og-image.png';
const BASE_URL = 'https://www.nashatasvatba.in';

export default function SEO({
  title,
  description,
  ogTitle,
  ogDescription,
  ogImage,
  ogUrl,
  noindex = false,
  nofollow = false,
  canonical,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const robots = noindex || nofollow
    ? ` ${noindex ? 'noindex' : 'index'}, ${nofollow ? 'nofollow' : 'follow'}`
    : undefined;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {robots && <meta name="robots" content={robots.trim()} />}
      {canonical && <link rel="canonical" href={canonical} />}

      <meta property="og:title" content={ogTitle || title || SITE_NAME} />
      <meta property="og:description" content={ogDescription || description || DEFAULT_DESCRIPTION} />
      <meta property="og:image" content={ogImage || DEFAULT_OG_IMAGE} />
      <meta property="og:url" content={ogUrl || canonical || BASE_URL} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="bg_BG" />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || title || SITE_NAME} />
      <meta name="twitter:description" content={ogDescription || description || DEFAULT_DESCRIPTION} />
      <meta name="twitter:image" content={ogImage || DEFAULT_OG_IMAGE} />
    </Helmet>
  );
}
